// TODO divide into modules
import {
  Category,
  Department,
  Institution,
  LearningObject,
  PagerResponse,
  Procedure,
  Study,
  User,
  UserRole,
  GetMostPopularProceduresResponse, GetInfrequentProceduresResponse,
  GetNursesExperienceResponse,
  GetNurseAgeExperienceStatsResponse,
  GetNurseAgeStatsResponse,
  Patient,
  GetNurseExperienceStatsResponse, GetAverageShiftDataResponse, GetAveragePatientAcuityDataResponse,
} from '@/generated/graphql'

class State {
  institutions: Array<Institution> = []
  institutionPageInfo: PagerResponse = {}
  refreshInstitutions = false
  currentUserIsActiveSub = false
  localeOverride: string = null
  currentUser: User = null
  currentRoles: UserRole[] = []
  impersonatedUser = false
  procedures: Array<Procedure> = []
  activeProcedure: Procedure = null
  procedurePageInfo: PagerResponse = {}
  refreshProcedures = false
  categoryList: Array<Category> = []
  users: Array<User> = []
  userPageInfo: PagerResponse = {}
  departmentsList: Department[] = []
  refreshDepartments = false
  studies: Study[] = []
  studyResults: Study[] = []
  studyPageInfo: PagerResponse = {}
  activeStudy: Study = null
  refreshStudies = false
  learningObjectLists: LearningObject[] = []
  refreshLearningObjects = false
  learningObjectsPageInfo: PagerResponse = {}
  mostPopularProcedures: GetMostPopularProceduresResponse
  infrequentsProcedures: GetInfrequentProceduresResponse
  nursesExperience: GetNursesExperienceResponse
  nurseAgeExperienceStats: GetNurseAgeExperienceStatsResponse
  nurseAgeStats: GetNurseAgeStatsResponse
  nurseSexStats: GetNurseExperienceStatsResponse
  shiftAverageStats: GetAverageShiftDataResponse
  acuityAverageStats: GetAveragePatientAcuityDataResponse
  patientsPageInfo: PagerResponse = {}
  visitsPageInfo: PagerResponse = {}
  patientsList: Patient[] = []
  fiveMostFrequentlyProcedures: any
  fiveLeastFrequentlyProcedures: any
  surveyResults: any
  fiveMostAssistedProcedures: any
  shiftIntensityChart: any
  shiftTirednessChart: any
  tableShowSize = 5
  shiftVisits: any[]
  nurseHistoryLocation: any
  // Module states
  departments: {
    departments: any[]
    departmentsPageInfo: PagerResponse
    refreshDepartments: boolean
  }
  roles: {
    roles: any[]
  }
}

export default State
